import { Circle } from 'rc-progress';
import styled, { css } from 'styled-components';
import { rotate } from 'styles/animations';
import { getThemeColor } from 'utils/styled';
import { RingStyleProps } from './types';

export const Root = styled.div`
  fill: ${getThemeColor('actionPrimary')};
  position: relative;
`;

export const LabelContainer = styled.svg`
  left: 0;
  position: absolute;
  top: 0;
`;

export const Ring = styled(Circle)<RingStyleProps>`
  ${({ $isIndeterminate }) =>
    $isIndeterminate && css`animation ${rotate} 1s linear infinite`};
`;
